import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
function Toast({ message, variant = "success", duration = 3e3, onDismiss }) {
  const [exiting, setExiting] = useState(false);
  const timerRef = useRef(null);
  const exitTimerRef = useRef(null);
  function startDismiss() {
    if (exiting) return;
    setExiting(true);
    exitTimerRef.current = setTimeout(() => {
      onDismiss();
    }, 350);
  }
  useEffect(() => {
    timerRef.current = setTimeout(() => startDismiss(), duration);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (exitTimerRef.current) clearTimeout(exitTimerRef.current);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `toast toast--${variant}${exiting ? " toast--exit" : ""}`,
      role: "status",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ jsx("div", { className: "toast__dot" }),
        /* @__PURE__ */ jsxs("div", { className: "toast__body", children: [
          /* @__PURE__ */ jsx("span", { className: "toast__message", children: message }),
          /* @__PURE__ */ jsx("span", { className: "toast__sub", children: "just now" })
        ] }),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "toast__close",
            "aria-label": "Dismiss notification",
            onClick: startDismiss,
            children: "\u2715"
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "toast__bar",
            style: { animationDuration: `${duration}ms` }
          }
        )
      ]
    }
  );
}
export {
  Toast
};
